import _regeneratorRuntime from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/MyAccount_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var RedirectTransport =
/*#__PURE__*/
function () {
  function RedirectTransport() {
    var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, RedirectTransport);

    this.storage = settings.storage || window.localStorage;
    this.original_uri = settings.original_uri || window.location.href;
    this.redirect_uri = settings.redirect_uri || this.original_uri.split(/[#?]/g)[0];
    this.post_logout_redirect_uri = settings.post_logout_redirect_uri || this.redirect_uri;
  }

  _createClass(RedirectTransport, [{
    key: "navigateTo",
    value: function navigateTo(resource_uri) {
      window.location.href = resource_uri;
    }
  }, {
    key: "signin",
    value: function () {
      var _signin = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(oidcClient, grant) {
        var original_uri;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                original_uri = this.original_uri;

                if (!/\berror=/.test(original_uri)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", Promise.reject(new Error("Unable to authorize.")));

              case 5:
                if (!/\bstate=/.test(original_uri)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", this.signinRedirectCallback(oidcClient));

              case 9:
                return _context.abrupt("return", this.signinRedirectEntry(oidcClient, grant));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function signin(_x, _x2) {
        return _signin.apply(this, arguments);
      }

      return signin;
    }()
  }, {
    key: "signinRedirectEntry",
    value: function () {
      var _signinRedirectEntry = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(oidcClient, grant) {
        var original_uri, redirect_uri, defaultParams, authorizationParams, defaultState, grantState, authorizationState, authorizationUrl;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                original_uri = this.original_uri, redirect_uri = this.redirect_uri;
                defaultParams = {
                  redirect_uri: redirect_uri
                };
                _context2.next = 4;
                return oidcClient.createAuthorizationParams(defaultParams);

              case 4:
                authorizationParams = _context2.sent;
                defaultState = {
                  client_id: authorizationParams["client_id"],
                  state: authorizationParams["state"],
                  redirect_uri: redirect_uri,
                  original_uri: original_uri
                };
                _context2.next = 8;
                return grant.enrich(authorizationParams);

              case 8:
                grantState = _context2.sent;
                authorizationState = Object.assign(defaultState, grantState);
                _context2.prev = 10;
                this.storage.setItem(authorizationState.state, JSON.stringify(authorizationState));
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](10);
                throw new Error("Unable to authorize due to the storage reason: " + _context2.t0.message);

              case 17:
                _context2.next = 19;
                return oidcClient.createAuthorizationUrl(authorizationParams);

              case 19:
                authorizationUrl = _context2.sent;
                this.navigateTo(authorizationUrl);
                return _context2.abrupt("return", null);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 14]]);
      }));

      function signinRedirectEntry(_x3, _x4) {
        return _signinRedirectEntry.apply(this, arguments);
      }

      return signinRedirectEntry;
    }()
  }, {
    key: "signinRedirectCallback",
    value: function () {
      var _signinRedirectCallback = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(oidcClient) {
        var original_uri, authorizationResponse, tokenResponse, authorizationState, authorizationCode, tokenRequest;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                original_uri = this.original_uri;
                _context3.next = 3;
                return oidcClient.parseAuthorizationResponse(original_uri);

              case 3:
                authorizationResponse = _context3.sent;
                tokenResponse = null;
                authorizationState = JSON.parse(this.storage.getItem(authorizationResponse["state"]) || null);

                if (authorizationState) {
                  _context3.next = 8;
                  break;
                }

                throw new Error("Missing state.");

              case 8:
                if (!authorizationResponse["access_token"]) {
                  _context3.next = 12;
                  break;
                }

                tokenResponse = authorizationResponse;
                _context3.next = 20;
                break;

              case 12:
                authorizationCode = authorizationResponse["code"];

                if (authorizationCode) {
                  _context3.next = 15;
                  break;
                }

                throw new Error("Missing authorization code.");

              case 15:
                tokenRequest = {
                  grant_type: "authorization_code",
                  code: authorizationCode,
                  redirect_uri: authorizationState["redirect_uri"]
                };

                if (authorizationState["code_verifier"]) {
                  tokenRequest["code_verifier"] = authorizationState["code_verifier"];
                }

                _context3.next = 19;
                return oidcClient.performTokenRequest(tokenRequest);

              case 19:
                tokenResponse = _context3.sent;

              case 20:
                // NOTE: restore browser state
                this.storage.removeItem(authorizationResponse["state"]);

                if (authorizationState.original_uri) {
                  window.history.replaceState(null, document.title, authorizationState.original_uri);
                }

                return _context3.abrupt("return", tokenResponse);

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function signinRedirectCallback(_x5) {
        return _signinRedirectCallback.apply(this, arguments);
      }

      return signinRedirectCallback;
    }()
  }, {
    key: "refresh",
    value: function refresh(oidcClient, refresh_token) {
      var tokenRequest = {
        grant_type: "refresh_token",
        refresh_token: refresh_token
      };
      return oidcClient.performTokenRequest(tokenRequest);
    }
  }, {
    key: "signout",
    value: function () {
      var _signout = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(oidcClient, id_token, redirect_uri) {
        var params, post_logout_redirect_uri, endSessionUrl;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                params = {};

                if (id_token) {
                  params.id_token_hint = id_token;
                }

                post_logout_redirect_uri = redirect_uri || this.post_logout_redirect_uri;

                if (post_logout_redirect_uri) {
                  params.post_logout_redirect_uri = post_logout_redirect_uri;
                }

                _context4.next = 6;
                return oidcClient.createEndSessionUrl(params);

              case 6:
                endSessionUrl = _context4.sent;
                this.navigateTo(endSessionUrl);
                return _context4.abrupt("return", null);

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function signout(_x6, _x7, _x8) {
        return _signout.apply(this, arguments);
      }

      return signout;
    }()
  }]);

  return RedirectTransport;
}();